import { useEffect, useRef, useState } from "react";
import Select from "react-tailwindcss-select";
import "./styles.css";
import { useTranslation } from "react-i18next";

const SearchSelect = ({
  options,
  formik,
  name,
  onChange,
  label,
  placeholder,
  onSearch,
  menuClassName,
}) => {
  const [menuPlacement, setMenuPlacement] = useState("bottom");
  const selectRef = useRef(null);

  useEffect(() => {
    const handlePosition = () => {
      if (!selectRef.current) return;
      const rect = selectRef.current.getBoundingClientRect();
      const dropdownHeight = 200;
      const spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow < dropdownHeight) {
        setMenuPlacement("top");
      } else {
        setMenuPlacement("bottom");
      }
    };

    handlePosition();
    window.addEventListener("resize", handlePosition);
    return () => window.removeEventListener("resize", handlePosition);
  }, []);
  const [value, setValue] = useState(null);
  const handleSelect = (val) => {
    setValue(val);
    formik?.setFieldValue(name, val);
    formik?.setFieldTouched(name, true);
    if (!onChange) return;
    onChange(val);
  };

  const { t } = useTranslation();
  return (
    <div className="relative w-full" ref={selectRef}>
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label}
        </label>
      )}
      <Select
        value={value}
        options={options || []}
        placeholder={placeholder || t("select")}
        onSearchInputChange={onSearch}
        onChange={handleSelect}
        classNames={{
          menuButton: ({ isDisabled }) =>
            `flex text-sm text-mainGray items-center select-menu h-8 px-2 border border-[#88888880] rounded-[5px] shadow-sm transition-all duration-300 focus:outline-none  ${
              isDisabled
                ? "bg-gray-200"
                : "bg-sideBar hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
            } ${menuClassName}`,
          listItem: ({ isSelected }) =>
            `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate  ${
              isSelected
                ? `text-white bg-sideBar`
                : `text-gray-400 hover:bg-blue-950 hover:text-blue-500`
            }`,
          menu: `absolute z-10 w-full bg-mainBg shadow-lg border rounded text-sm text-gray-700 ${
            menuPlacement === "top" ? "bottom-full mb-2" : "mt-1.5"
          }`,
        }}
      />
    </div>
  );
};

export default SearchSelect;
